import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { useNavigate, useLocation } from "react-router-dom";

const getHomePath = () => {
  try {
    const userDetails = localStorage.getItem("userDetail");
    const user = userDetails ? JSON.parse(userDetails) : null;

    if (!user?.email) {
      return "/LoginPage";
    }

    const isCodeGen = user?.company?.logintype === "codegen";
    return isCodeGen ? "/" : "/new/dashboard";
  } catch (error) {
    console.error("Failed to parse user details from localStorage", error);
    return "/LoginPage";
  }
};

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const homePath = getHomePath();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "60vh",
        px: 3,
        py: 6,
      }}
    >
      <SearchOffIcon sx={{ fontSize: 64, color: "#FF5336", mb: 2 }} />

      <Typography sx={{ fontSize: 64, fontWeight: 700, color: "#242f3f", lineHeight: 1 }}>
        404
      </Typography>

      <Typography variant="h6" sx={{ mt: 1, fontWeight: 600, color: "#242f3f" }}>
        Page not found
      </Typography>

      <Typography variant="body2" sx={{ mt: 1, maxWidth: 480, color: "text.secondary" }}>
        The page you are looking for doesn&apos;t exist or may have been moved.
      </Typography>

      <Typography
        variant="caption"
        sx={{
          mt: 1.5,
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          backgroundColor: "#f5f7f9",
          color: "text.secondary",
          fontFamily: "monospace",
          wordBreak: "break-all",
        }}
      >
        {location.pathname}
      </Typography>

      <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{
            textTransform: "none",
            color: "#242f3f",
            borderColor: "#d6dbe1",
            "&:hover": { borderColor: "#242f3f", backgroundColor: "#f5f7f9" },
          }}
        >
          Go back
        </Button>

        <Button
          variant="contained"
          startIcon={<HomeOutlinedIcon />}
          onClick={() => navigate(homePath, { replace: true })}
          sx={{
            textTransform: "none",
            backgroundColor: "#FF5336",
            boxShadow: "none",
            "&:hover": { backgroundColor: "#e6421f", boxShadow: "none" },
          }}
        >
          {homePath === "/LoginPage" ? "Go to login" : "Go to dashboard"}
        </Button>
      </Stack>
    </Box>
  );
};

export default NotFound;
